import G from "./design-system.es115.js";
import L from "./design-system.es51.js";
import { resolveComponent as o, openBlock as d, createBlock as s, withCtx as e, createVNode as l, createElementVNode as B, toDisplayString as p, createTextVNode as a, createElementBlock as g, Fragment as D, renderList as x, mergeProps as k, createCommentVNode as q } from "vue";
/* empty css                    */
import E from "./design-system.es128.js";
import A from "./design-system.es38.js";
import F from "./design-system.es39.js";
import P from "./design-system.es82.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
import Q from "./design-system.es62.js";
/* empty css                    */
/* empty css                    */
import j from "./design-system.es116.js";
import z from "./design-system.es25.js";
/* empty css                    */
import H from "./design-system.es37.js";
import J from "./design-system.es94.js";
import K from "./design-system.es106.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import R from "./design-system.es74.js";
import U from "./design-system.es75.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
const W = {
  name: "DsTableGridTrowser",
  components: {
    Trowser: G,
    Dropdown: L,
    DsButton: A,
    OutlineButton: P,
    ButtonGroup: F,
    Stack: J,
    Inline: Q,
    Box: H,
    DsText: K,
    MenuItems: U,
    MenuItem: R
  },
  props: {
    /**
     * Count of selected items
     */
    selectedCount: Number,
    /**
     * The label to display in trowser describing the selected items
     */
    selectedItemLabel: String,
    /**
     * The label to display in trowser actions button
     */
    actionsLabel: String,
    /**
     * Label value object array of options to take on selected rows
     */
    selectedOptions: Array,
    /**
     * Toggle to show the trowser or not
     */
    show: Boolean
  },
  emits: ["selectedClicked"],
  setup() {
    const t = j(), n = z({ breakpoint: "medium" });
    return {
      i18n: t,
      isMedium: n
    };
  },
  computed: {
    selectedOptionsSorted() {
      const { selectedOptions: t } = this;
      let n = null;
      const r = t.filter((m) => (m.value === "delete" && (n = m), m.value !== "delete"));
      return n && r.push(n), r;
    }
  },
  methods: {
    handleButtonClick(t) {
      this.$emit("selectedClicked", t);
    },
    isDelete(t) {
      return t === "delete";
    },
    // Temporary to support existing global class uses
    itemVariant(t) {
      return t != null && t.includes("text-button") || t != null && t.includes("secondary") ? "text" : "outline";
    },
    itemDestructive(t) {
      return t == null ? void 0 : t.includes("negative");
    }
  }
}, X = { "data-qa": "selected-count" };
function Y(t, n, r, m, Z, i) {
  const w = o("DsText"), C = o("DsButton"), v = o("OutlineButton"), b = o("MenuItem"), h = o("MenuItems"), y = o("Dropdown"), I = o("ButtonGroup"), O = o("Inline"), T = o("Stack"), S = o("Box"), M = o("Trowser");
  return d(), s(M, {
    show: r.show,
    class: "table-grid-trowser"
  }, {
    default: e(() => [
      l(S, { padding: "spacing-200" }, {
        default: e(() => [
          l(T, {
            "align-y": "center",
            "align-x": "center",
            fill: ""
          }, {
            default: e(() => [
              l(O, {
                space: "spacing-400",
                "align-y": "center"
              }, {
                default: e(() => [
                  l(w, { variant: "body" }, {
                    default: e(() => [
                      B("span", X, p(r.selectedCount), 1),
                      n[0] || (n[0] = a()),
                      B("span", null, p(r.selectedItemLabel || m.i18n.messages["tablegrid.selected"]), 1)
                    ]),
                    _: 1
                  }),
                  n[2] || (n[2] = a()),
                  r.selectedOptions ? (d(), s(I, { key: 0 }, {
                    default: e(() => [
                      m.isMedium || r.selectedOptions.length <= 1 ? (d(!0), g(D, { key: 0 }, x(i.selectedOptionsSorted, ({
                        label: u,
                        value: c,
                        className: _,
                        ...f
                      }) => (d(), s(C, k({
                        key: c,
                        variant: i.itemVariant(_),
                        destructive: i.isDelete(c) || i.itemDestructive(_),
                        "data-qa": u,
                        ref_for: !0
                      }, f, {
                        onClick: (V) => i.handleButtonClick(c)
                      }), {
                        default: e(() => [
                          a(p(u), 1)
                        ]),
                        _: 2
                      }, 1040, ["variant", "destructive", "data-qa", "onClick"]))), 128)) : (d(), s(y, {
                        key: 1,
                        next: ""
                      }, {
                        default: e((u) => [
                          l(v, k(u, { "trailing-icon": "chevron-down" }), {
                            default: e(() => [
                              a(p(r.actionsLabel || m.i18n.messages["tablegrid.actions"]), 1)
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        content: e(() => [
                          l(h, null, {
                            default: e(() => [
                              (d(!0), g(D, null, x(i.selectedOptionsSorted, ({
                                label: u,
                                value: c,
                                className: _,
                                ...f
                              }) => (d(), s(b, k({
                                key: c,
                                destructive: i.isDelete(c) || i.itemDestructive(_),
                                ref_for: !0
                              }, f, {
                                onClick: (V) => i.handleButtonClick(c)
                              }), {
                                default: e(() => [
                                  a(p(u), 1)
                                ]),
                                _: 2
                              }, 1040, ["destructive", "onClick"]))), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    ]),
                    _: 1
                  })) : q("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]);
}
const At = /* @__PURE__ */ E(W, [["render", Y]]);
export {
  At as default
};
//# sourceMappingURL=design-system.es104.js.map
